<svelte:options accessors/>
<script lang="ts">
    import type {IAddress} from "../../interfaces";
    import Address from "./Address.svelte";
    import AddressForm from "./AddressForm.svelte";
    import {createEventDispatcher, onMount} from "svelte";

    const dispatch = createEventDispatcher();

    export let data: Array<IAddress>;
    export let departments: Array<any>;
    export let enableSelect: boolean = false;
    export let enableRemove: boolean = false;

    let active: string = '';
    let activeEditing: string = '';
    let selected: IAddress;
    let addressForm;

    onMount(() => {
        if (data && data.length > 0) {
            active = data[0].id;
        }
    });

    let editMode = false;

    function remove() {

    }

    function edit(address) {
        const data = JSON.parse(JSON.stringify(address));
        data.department = departments.find(d => d.code === data.department.id);
        data.city = data.department.cities.find((c) => c.code === data.city.id)
        editMode = true;
        setTimeout(() => {
            if (addressForm) {
                addressForm.$set({
                    data: data
                });
            }
        }, 100);
    }

    function create(event) {
        const {detail} = event;
        editMode = false;
        dispatch('upsert', detail);
    }

    function setSelected(address: IAddress) {
        data.forEach(a => {
            if (a.id !== address.id) {
                a.selected = false;
            }
        });
        data = [...data];
    }
</script>
{#if !editMode}
    <section>
        <div class="container max-w-900px mx-auto">
            {#each data as item (item.id)}
                <div class="pointer">
                    <Address data="{item}"
                             {enableSelect}
                             {enableRemove}
                             on:select={()=>setSelected(item)}
                             on:edit={()=>edit(item)}/>
                </div>
            {:else}
                <p>No hay direcciones registradas</p>
            {/each}
            <div class="box py-1">
                <div class="btn accent"
                     on:click={()=> editMode= true}>
                    Agregar nueva dirección
                </div>
            </div>
        </div>
    </section>
{:else}
    <AddressForm bind:this={addressForm}
                 {departments}
                 on:cancel={()=>editMode = false}
                 on:save={create}/>
{/if}